import Login from "./Login/Login";
import Page404 from "./Page404/Page404";
import Page500 from "./Page500/Page500";
import UnderConstruction from "./UnderConstruction";
import ResetPassword from "./Forgot";

export { Login, Page404, Page500, UnderConstruction, ResetPassword };
